import {Dialog, DialogContent, DialogActions, DialogTitle, Typography, Button} from '@mui/material';
import {useTheme} from '@mui/material/styles';

/**
 * Component representing a confirmation dialog with custom text for buttons.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Function} props.onClose - Function to be called when the close button is clicked.
 * @param {Function} props.onConfirm - Function to be called when the confirm button is clicked.
 * @param {boolean} props.open - Determines whether the dialog is open or closed.
 * @param {string} props.title - The title of the dialog.
 * @param {string} props.subtitle - The subtitle or content of the dialog.
 * @param {string} props.onCloseText - The text for the close button.
 * @param {string} props.onConfirmText - The text for the confirm button.
 * @returns {JSX.Element} The ConfirmationDialog2 component.
 */
const ConfirmationDialog2 = ({onClose, onConfirm, open, title, subtitle, onCloseText, onConfirmText}) => {
  const theme = useTheme();

  const dialogStyle = {
    '& .MuiPaper-root': {
      borderRadius: 7,
      overflowX: 'hidden',
    },
    position: 'absolute',
    top: theme.spacing(5),
    paddingY: theme.spacing(2),
  };
  return (
    <Dialog disableRestoreFocus open={open} maxWidth="sm" sx={dialogStyle}>
      <DialogTitle
        sx={{
          paddingTop: theme.spacing(6),
          pb: theme.spacing(1),
          textAlign: 'center',
        }}
      >
        <Typography component="span" variant="h6" fontWeight={'bold'}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{paddingY: theme.spacing(5), textAlign: 'center'}}>
        <Typography variant="subtitle2"> {subtitle}</Typography>
      </DialogContent>
      <DialogActions
        sx={{
          paddingBottom: theme.spacing(2),
          paddingX: theme.spacing(4),
          display: 'flex',
          justifyContent: 'space-between',
          gap: {
            xs: 2,
            sm: 9,
          },
        }}
      >
        <Button variant="text" onClick={onClose}>
          {onCloseText}
        </Button>
        <Button variant="text" onClick={onConfirm}>
          {onConfirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog2;
